import React from 'react';
import { SvgIconComponent } from '@mui/icons-material';
import './svg-icon.component.scss';

const MUIcon: { [key: string]: SvgIconComponent } = require('@mui/icons-material');

export type IconesSVGComponentProps = {
  iconName: string;
  className?: string;
}

function IconesSVGComponent(props: IconesSVGComponentProps){
  const Icon = MUIcon[props.iconName];

  return (
    <>
      {Icon && <Icon className={props.className} />}
    </>
  )
}

export default IconesSVGComponent;
